export default __webpack_public_path__ + "static/media/google-play-soon.850a161d.svg";